import { translateCountCategory } from "@/utils/countCategory";
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { saveAs } from "file-saver";
import xlsx from "json-as-xlsx";

export default {
  data() {
    return {
      isLoadingDownloadXlsx: false,
      isLoadingDownloadIcalendar: false,
      workers_names: [],
    };
  },
  methods: {
    // FT-082: exports honor the page's active filters (list/board both expose filterParams).
    exportFilterParams() {
      return this.filterParams ? this.filterParams() : {};
    },
    findWorker(id) {
      let name;
      if (this.workers_names.find((worker) => worker.id == id)) {
        name = this.workers_names.find((worker) => worker.id == id).name
          ? this.workers_names.find((worker) => worker.id == id).name
          : this.workers_names.find((worker) => worker.id == id).email;
      }
      if (name) {
        return name;
      } else {
        return id;
      }
    },
    toXlsx() {
      if (this.isStaff) {
        this.isLoadingDownloadXlsx = true;
        this.axios
          .get("/api/v1/get_workers_names_with_ids", {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.workers_names = response.data;
            this.axios
              .get(`/api/v1/bookings_export_excel`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
                params: this.exportFilterParams(),
                timeout: 120000, // большой экспорт может не влезть в глобальные 30с
              })
              .then((response) => {
                let bookings = [];
                let counts = [];
                let clients = [];
                let workers = [];
                response.data.data.forEach((booking) => {
                  let attributes = booking.attributes;
                  bookings.push(attributes);
                  booking.relationships.counts.data.forEach((item) => {
                    let included_counts = response.data.included.filter(
                      (count) => count.id == item.id
                    );
                    included_counts.forEach((count) => {
                      counts.push(count.attributes);
                    });
                  });
                });
                let data = [
                  {
                    sheets: "Bookings",
                    columns: [
                      { label: "ID", value: "id" },
                      { label: this.$t("custom.created_at"), value: "created_at" },
                      {
                        label: this.$t("bookings.client_name"),
                        value: (row) => {
                          if (row.entity && row.entity_name) {
                            return row.entity_name;
                          } else {
                            return `${row.last_name || ''} ${row.first_name || ''} ${row.middle_name || ''}`.trim();
                          }
                        }
                      },
                      { label: this.$t("cars.name"), value: "car_name" },
                      { label: this.$t("doc_variables.car_code"), value: "car_code" },

                      { label: this.$t("bookings.start_date"), value: "start_date" },
                      { label: this.$t("bookings.end_date"), value: "end_date" },
                      { label: this.$t("bookings.days"), value: "days" },
                      { label: this.$t("bookings.add_hours_short"), value: "additional_hours" },
                      { label: this.$t("bookings.price"), value: "price" },
                      {
                        label: this.$t("bookings.rental_cost"),
                        value: "rental_cost",
                      },
                      { label: this.$t("bookings.delivery"), value: "delivery" },
                      {
                        label: this.$t("bookings.checkout"),
                        value: "delivery_end",
                      },
                      // UAT 2026-08-07: колонки идут подряд — в файле было два
                      // столбца «Оборудование»; легаси-сумма разведена лейблом.
                      { label: this.$t("bookings.other_equipment"), value: "equipment" },
                      // FT-102: каталожное оборудование
                      { label: this.$t("booking_addons.title"), value: "addons_cost" },
                      { label: this.$t("bookings.insurance"), value: "insurance" },
                      {
                        label: this.$t("bookings.clean"),
                        value: "clean_payment",
                      },
                      {
                        label: this.$t("bookings.add_drivers_2"),
                        value: "add_drivers_cost",
                      },
                      { label: this.$t("bookings.hours_cost"), value: "hours_cost" },
                      {
                        label: this.$t("bookings.mileage_cost"),
                        value: "mileage_cost",
                      },
                      { label: this.$t("bookings.damages"), value: "damage" },
                      { label: this.$t("bookings.gas"), value: "gas" },
                      { label: this.$t("bookings.for_fines"), value: "fine" },
                      { label: this.$t("bookings.other"), value: "other" },
                      {
                        label: this.$t("bookings.for_other_end"),
                        value: "other_end",
                      },
                      {
                        label: this.$t("bookings.hours_cost_end"),
                        value: "hours_cost_end",
                      },
                      {
                        label: this.$t("clients.client_source"),
                        value: "client_source",
                      },
                      {
                        label: this.$t("clients.source"),
                        value: "source",
                      },
                      {
                        label: this.$t("bookings.checkiner"),
                        value: (row) => {
                          return this.findWorker(row.start_worker_id);
                        },
                      },
                      {
                        label: this.$t("bookings.checkouter"),
                        value: (row) => {
                          return this.findWorker(row.end_worker_id);
                        },
                      },
                    ],
                    content: bookings,
                  },
                  {
                    sheets: "Payments",
                    columns: [
                      { label: "ID", value: "id" },
                      { label: this.$t("custom.created_at"), value: "created_at" },
                      { label: this.$t("custom.amount"), value: "sum" },
                      { label: this.$t("custom.operation"), value: "operation" },
                      { label: this.$t("counts.about"), value: "description" },
                      { label: this.$t("money.terminal"), value: "cashless" },
                      { label: this.$t("money.card_to_card"), value: "cash_card" },
                      { label: this.$t("money.cash"), value: "cash" },
                      { label: this.$t("money.from_entity"), value: "entity" },
                      {
                        label: this.$t("custom.group"), value: (row) => {
                          return this.translateCategory(row.group);
                        }
                      },
                      { label: this.$t("custom.car"), value: "car_code" },
                      { label: this.$t("bookings.booking"), value: "booking_id" },
                      { label: this.$t("debts.debt"), value: "debt_id" },
                      { label: this.$t("employers.partner"), value: "investor_id" },
                      { label: this.$t("counts.completed"), value: "completed" },
                    ],
                    content: counts,
                  },
                ];
                let settings = {
                  fileName: "bookings", // Name of the resulting spreadsheet
                  extraLength: 3, // A bigger number means that columns will be wider
                  writeMode: "write", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
                  writeOptions: {
                    bookType: "xlsx",
                    type: "array",
                  }, // Style options from https://docs.sheetjs.com/docs/api/write-options
                  RTL: false, // Display the columns from right-to-left (the default value is false)
                };
                let wbout = xlsx(data, settings);
                var blob_data = new Blob([new Uint8Array(wbout)], { type: "application/octet-stream" });
                if (!this.isNative) {
                  saveAs(blob_data, 'bookings.xlsx');
                } else {
                  if (Filesystem.checkPermissions()) {
                    const getBase64FromBlob = async (blob) => {
                      return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = () => {
                          const base64data = reader.result;
                          resolve(base64data);
                        }
                      });
                    }
                    getBase64FromBlob(blob_data).then(
                      (base64) => {
                        // save file
                        async function writeFile() {
                          return await Filesystem.writeFile({
                            path: 'bookings.xlsx',
                            data: base64,
                            directory: Directory.Documents,
                          });
                        }
                        let file_uri = null
                        let writedFile = writeFile().then((getUriResult) => {
                          // share file opened file
                          let shareFile = async () => {
                            await Share.share({
                              title: 'Download document',
                              files: [getUriResult.uri],
                            }).catch((error) => {
                              console.log("shareFile", error)
                            });
                          };
                          let sharedFile = shareFile();
                        }).catch((error) => {
                          console.log("shareFile", error)
                        });
                      }
                    );
                  } else {
                    Filesystem.requestPermissions();
                  }
                }
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.clients_load"));
                console.log(error);
              })
          })
          .catch((error) => {
            this.setError(error, "Something went wrong in get_workers_names");
            console.log(error);
          })
          .finally(() => (this.isLoadingDownloadXlsx = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    downloadIcalendar(id) {
      this.isLoadingDownloadIcalendar = true;
      this.axios.get(`/api/v1/active_bookings_icalendar`, {
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
        params: this.exportFilterParams(),
      })
        .then((response) => {
          this.isLoadingDownloadIcalendar = true;
          const blob_data = new Blob([response.data], { type: "text/calendar" });
          if (!this.isNative) {
            saveAs(blob_data, 'bookings.ics');
          } else {
            if (Filesystem.checkPermissions()) {
              const getBase64FromBlob = async (blob) => {
                return new Promise((resolve) => {
                  const reader = new FileReader();
                  reader.readAsDataURL(blob);
                  reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                  }
                });
              }
              getBase64FromBlob(blob_data).then(
                (base64) => {
                  // save file
                  async function writeFile() {
                    return await Filesystem.writeFile({
                      path: 'bookings.ics',
                      data: base64,
                      directory: Directory.Documents,
                    });
                  }
                  let file_uri = null
                  let writedFile = writeFile().then((getUriResult) => {
                    // share file opened file
                    let shareFile = async () => {
                      await Share.share({
                        title: 'Download document iCalendar format',
                        files: [getUriResult.uri],
                      }).catch((error) => {
                        console.log("shareFile", error)
                      });
                    };
                    let sharedFile = shareFile();
                  }).catch((error) => {
                    console.log("shareFile", error)
                  });
                }
              );
            } else {
              Filesystem.requestPermissions();
            }
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoadingDownloadIcalendar = false));
    },
  },
};
